// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"style_headerTitle__3OEpR","line":"style_line__1BICs","fontSize1":"style_fontSize1__J_m9h","bold":"style_bold__2IZYn"};